module.exports = __webpack_public_path__ + "static/img/question.824218bf.jpg";